// edit the vars below as needed during local development
const devBackend = false;
const devCcBackend = false;
const radioSsl = false;
const consoleSsl = false;
const ccSsl = false;
// set true to connect to the local EMQX container (the emqx-bridge flag must be on for the local backend)
const localEmqx = false;

/**
 * Whether the page itself is served over https. Read on call rather than at module load so this
 * module can be imported where `document` does not exist (a worker, or a unit test).
 */
function isSslPage(): boolean {
    return typeof document !== 'undefined' && document.location.href.startsWith('https://');
}

/** EMQX's local WebSocket listeners from docker-compose: plain ws, and TLS for an https page. */
const EMQX_WS_PORT = 8083;
const EMQX_WSS_PORT = 8084;

/**
 * Broker port for a local page. The local backend's embedded broker (3000/3443) is the default;
 * `useEmqx` points at the EMQX container instead, used while the `emqx-bridge` feature flag is on.
 */
export function resolveLocalPubSubPort(useDevBackend: boolean, useSsl: boolean, useEmqx: boolean): number {
    if (useDevBackend) return 443;
    if (useEmqx) return useSsl ? EMQX_WSS_PORT : EMQX_WS_PORT;
    return useSsl ? 3443 : 3000;
}

export function getLocalPubSubPort(): number {
    return resolveLocalPubSubPort(devBackend, isSslPage(), localEmqx);
}

export function getLocalSiblingUrl(subDomain: string): string {
    if (subDomain === 'app') {
        return 'http://localhost:4200';
    } else if (subDomain === 'radio') {
        return `${radioSsl ? 'https' : 'http'}://localhost:4201`;
    } else if (subDomain === 'console') {
        return `${consoleSsl ? 'https' : 'http'}://localhost:4202`;
    } else if (subDomain === 'api-controlcenter') {
        return devCcBackend
            ? 'https://api-controlcenter.weavixdev.com'
            : ccSsl ? 'https://localhost:3100' : 'http://localhost:3100';
    } else if (devBackend) {
        return `https://${subDomain}.weavixdev.com`;
    } else if (subDomain === 'api') {
        return isSslPage() ? 'https://localhost:3443' : 'http://localhost:3000';
    } else if (subDomain === 'mqtt') {
        return 'localhost';
    } else {
        throw new Error(`Unknown subdomain: ${subDomain}`);
    }
}
